<template>
  <div class="value_copy">
    <div
      class="value_copy__value"
      :class="{ 'value_copy__value--disabled': disabled }"
    >
      <input
        type="text"
        :value="value"
        ref="copyValue"
        readonly
        :disabled="disabled"
        :class="{ 'value_copy__value__input--disabled': disabled }"
      />
    </div>
    <div>
      <InlineButton @click="onClick()" :disabled="disabled">
        <template v-slot:icon
          ><font-awesome-icon :icon="['far', 'copy']" size="lg"
        /></template>
      </InlineButton>
    </div>
  </div>
</template>

<script>
import * as copy from "copy-to-clipboard";
import { faCopy } from "@fortawesome/pro-regular-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import InlineButton from "../atoms/InlineButton.vue";

library.add(faCopy);

export default {
  /**
   * @vuese
   */
  name: "FieldToClipboard",
  components: { InlineButton, FontAwesomeIcon },
  props: {
    // The value that the input wil yield and will be copied
    value: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
    },
  },
  methods: {
    async onClick() {
      if (this.disabled) return;

      await copy(this.value);
      this.$refs.copyValue.select();
      this.$emit("onCopied");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style_variables/style_variables.scss";

.value_copy {
  display: flex;
  width: 100%;
  flex-wrap: nowrap;
  height: 56px;
  &__value {
    background-color: $white;
    border: 1px solid $grey_mischka;
    border-radius: 4px;
    padding: 0 14px;
    flex-grow: 1;
    display: flex;
    align-items: center;
    &--disabled {
      background-color: $grey-bg;
      border-color: $grey_mischka;
    }
    input {
      @extend %body1_style;
      font-size: 1rem;
      border: none;
      padding: 0;
      width: 100%;
      outline: none;
    }
    &__input--disabled {
      pointer-events: none;
      background-color: unset;
      color: $grey_mischka;
      -webkit-text-fill-color: $grey_mischka; //Safari
    }
  }
}
</style>
